import { FC } from "react";
import { TabPanel } from "@smile2impress/components/relaunch";

import { FourColumnTabPanelProps } from "./FourColumnTabPanel.types";

export const FourColumnTabPanel: FC<FourColumnTabPanelProps> = ({
    children,
}) => (
    <TabPanel
        display="grid"
        gridTemplateColumns={[
            "repeat(2, 1fr)",
            "repeat(2, 1fr)",
            "repeat(4, 246.5px)",
        ]}
        columnGap={[1, 1, "76px"]}
        rowGap={[1, 1, 4]}
        justifyContent="center"
        px={[0, 0, 4]}
    >
        {children}
    </TabPanel>
);
